import axios from "axios"
import store from "../store/index"
import router from "../router"
import vue from "../main"
import { baseUrl } from "./url.js"
import { getRequest } from "../components/Common/Utils/Utils"
const qs = require("qs")

export let instance = axios.create({
  timeout: 600000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    Authorization: "Basic bmhmYXBwOm5oZmFwcF9PTTJCMUZsOVo0NmhtVnpN",
    "X-Requested-With": "XMLHttpRequest",
  },
})
console.log('baseUrl', baseUrl)
// if (process.env.NODE_ENV !== "dev") {
instance.defaults.baseURL = baseUrl
// }

let urlArr = [
  "/iot-auth/token",
  "/iot-auth/tokenWithCaptcha",
  "/iot-auth/oauth/getToken/newhope",
  // '/nhf-app/nutritionMage/nutritionRawPage'
  // '/nhf-app/factorystaffnutritionraw/selectNutritionPage'
]
let flagObj = {}
instance.interceptors.request.use(
  (config) => {
    let token = window.localStorage.getItem("accessToken")
    if (token) config.headers.common["iot-Auth"] = "bearer " + token
    let freshToken = getRequest("refreshToken", "?" + config.data)
    if (urlArr.includes(config.url)) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"
      if (freshToken) {
        store.commit("controlLoading", false)
        !config.closeLoading && store.commit("controlLoading", true)
      }
    } else {
      config.headers["Content-Type"] = "application/json"
      if (!config.closeLoading) {
        store.commit("controlLoading", true)
        flagObj[config.url] = true
      }
    }
    return config
  },
  (err) => {
    store.commit("controlLoading", false)
    return Promise.reject(err)
  }
)

instance.interceptors.response.use(
  (response) => {
    flagObj[response.config.url] = false
    store.commit("controlLoading", Object.values(flagObj).includes(true))
    if (response.status === 200) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response.data)
    }
  },
  (error) => {
    let { status, data, config } = error.response || {}
    flagObj[config.url] = false
    !config.closeLoading && store.commit("controlLoading", Object.values(flagObj).includes(true))
    let { msg, message } = data
    let token = window.localStorage.getItem("accessToken")
    store.commit("controlLoading", false)
    if (status) {
      switch (status) {
        case 400: {
          if (config.url == '/iot-system/menu/buttons' || config.url == '/iot-system/menu/routes') {
            if (config.url == '/iot-system/menu/routes') vue.$message.error('暂无工厂权限，请联系管理员')
          } else if (config.url.includes('opeconomicbenefit/opEconomicBenefitByPredictionId')) {
            vue.$message.error(msg || message, 6)
          } else {
            vue.$message.error(msg || message)
          }
          break
        }
        case 401: {
          if (token && (msg || message)) vue.$message.error(msg || message)
          // // 清除登录人名称
          window.localStorage.removeItem("userName")
          window.localStorage.removeItem("accessToken")
          window.localStorage.removeItem("loginTime")
          window.localStorage.removeItem("refreshToken")
          window.localStorage.removeItem("loginOutSrc")
          window.localStorage.removeItem("staffId")

          let src = window.location.href.split('/#')[1]
          if (src && src !== '/login') window.localStorage.setItem('targetUrl', src)
          router.push("/login")
          break
        }
        case 403:
          break
        case 404:
          break
        case 500:
          vue.$message.error(msg)
          break
        default:
      }
      return Promise.reject(error.response)
    }
  }
)
let instance2 = axios.create({
  timeout: 600000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    responseType: 'arraybuffer'
  },
  responseType: 'arraybuffer'
})
// if (process.env.NODE_ENV === "production") {
instance2.defaults.baseURL = baseUrl
// }
instance2.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('accessToken')
    if (token) config.headers.common['iot-Auth'] = 'bearer ' + token
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
export const fileDownload = (url, data) =>
  instance2.get(url, { params: data }).then(response => {
    let f = response.headers['Content-Disposition'] || response.headers['content-disposition']
    const type = response.headers['Content-Type'] || response.headers['content-type']
    if (!f) f = qs.parse(url.split('?')[1])['response-content-disposition']
    const fileNameStr = f.match(/filename=(.*)/)[1]
    const fileName = fileNameStr.split(';')[0]
    // 将二进制流转为blob
    const blob = new Blob([response.data], {
      type
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, decodeURI(fileName))
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', decodeURI(fileName))
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  })
let instance3 = axios.create({
  timeout: 1000000,
  headers: {
    contentType: "application/json;charset=utf-8",
    "Content-Type": "application/json;charset=utf-8",
  },
  responseType: 'arraybuffer'
})
instance3.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('accessToken')
    if (token) config.headers.common['iot-Auth'] = 'bearer ' + token
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
instance3.defaults.baseURL = baseUrl
export const fileDownload2 = (url, data) =>
  instance3.post(url, data).then(response => {
    const f = response.headers['Content-Disposition'] || response.headers['content-disposition']
    const type = response.headers['Content-Type'] || response.headers['content-type']
    const fileNameStr = f.match(/filename=(.*)/)[1]
    const fileName = fileNameStr.split(';')[0]
    // 将二进制流转为blob
    const blob = new Blob([response.data], {
      type
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, decodeURI(fileName))
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', decodeURI(fileName))
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  })
export const get = (url, params) => instance.get(url, { params, closeLoading: true })
export const getForm = (url, params) =>
  instance.get(
    url,
    { params, closeLoading: true },
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  )
export const post = (url, data) => { return instance.post(url, data, { closeLoading: true }) }
export const postForm = (url, data) =>
  instance.post(url, qs.stringify(data), {
    headers: { "content-type": "application/x-www-form-urlencoded" },
    closeLoading: true,
  })
